window.$ = window.jQuery = require("jquery");
import $ from 'jquery';
let Functions = require('./web/v1/functions');

$(document).ready(function (){
    $.ajaxSetup({
        headers: {
            'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
        }
    });

    $(".devise-edit-password #new_user").on('submit', function (e) {
        e.preventDefault();
        var agreement = document.getElementById('user_terms_and_conditions');
        var password = document.getElementById('new-password');
        var password_confirmation = document.getElementById('confirm-new-password');
        if (agreement && agreement.checked && password && password_confirmation && password.value == password_confirmation.value && password.value.length >= 8) {
            this.submit();
        } else {
            let errors = "ERROR";
            if (!agreement) {
                errors += "\n* missing agreement";
            } else {
                if (!agreement.checked) {
                    errors += "\n* terms & conditions should be checked";
                }
            }

            if (!password) {
                errors += "\n* missing password";
            } else {
                if (password && password.value.length < 8) {
                    errors += "\n* password should be at least 8 characters long";
                }
            }

            if (!password_confirmation) {
                errors += "\n* missing password confirmation";
            } else {
                if (password_confirmation && password_confirmation.value.length < 8) {
                    errors += "\n* password confirmation should be at least 8 characters long";
                }
            }

            if (password && password_confirmation && password.value != password_confirmation.value) {
                errors += "\n* password and password confirmation should match";
            }

            alert(errors);
        }
    });

    let $input_email = $('.input-email');
    if ( $input_email.length > 0 ) {
        $input_email.change( function () {
            $input_email.val(this.value);
        });
        $input_email.change();
    }


    Functions.initTogglePasswordField();

    var email = getUrlParam('email', false);
    if (email && emailIsValid(email)) {
        document.getElementById('user_email').value = email;
        document.getElementById('user_password').focus();
    }

    var login_type = getUrlParam('type', false);
    if (login_type && login_type === 'password') {
        let $sign_in_password = $('.sign-in-password')
        let $sign_in_code = $('.sign-in-code');

        if ( $sign_in_password ) {
            $sign_in_password.removeClass('d-none');
            $sign_in_password.addClass('d-block');
        }

        if ( $sign_in_code ) {
            $sign_in_code.removeClass('d-block');
            $sign_in_code.addClass('d-none');
        }
    }

    window.body_data = $("body").data();
    if ( window.body_data['controllerClass'] === 'SessionsController' && window.body_data["actionName"] === 'sign_in_code') {
        window.history.replaceState(null, '', window.location.pathname);
        initPinContainer();

        $('.submit-sign-in-code').click(function() {
            let pin_code = '';
            $('.pin-number').each(function(i, obj) {
                pin_code += obj.value;
            });

            $('#user_sign_in_code').val(pin_code);
            $('#login').click();
        });
    }

    $('.use-sign-in-code').click(function () {
        let $sign_in_password = $('.sign-in-password')
        let $sign_in_code = $('.sign-in-code');

        if ( $sign_in_password ) {
            $sign_in_password.removeClass('d-block');
            $sign_in_password.addClass('d-none');
        }

        if ( $sign_in_code ) {
            $sign_in_code.removeClass('d-none');
            $sign_in_code.addClass('d-block');
        }
    });

    $('.use-password').click(function () {
        let $sign_in_password = $('.sign-in-password')
        let $sign_in_code = $('.sign-in-code');

        if ( $sign_in_password ) {
            $sign_in_password.removeClass('d-none');
            $sign_in_password.addClass('d-block');
        }

        if ( $sign_in_code ) {
            $sign_in_code.removeClass('d-block');
            $sign_in_code.addClass('d-none');
        }
    });
});

function getUrlParam(parameter, defaultvalue) {
    var urlparameter = defaultvalue;
    if (window.location.href.indexOf(parameter) > -1) {
        urlparameter = getUrlVars()[parameter];
    }
    return urlparameter;
}

function getUrlVars() {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
        vars[key] = value;
    });
    return vars;
}

function emailIsValid(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}

function initPinContainer() {
    var pinContainer = document.querySelector(".pin-code");
    console.log('There is ' + pinContainer.length + ' Pin Container on the page.');

    pinContainer.addEventListener('keyup', function (event) {
        var target = event.srcElement;

        var maxLength = parseInt(target.attributes["maxlength"].value, 10);
        var myLength = target.value.length;

        if (myLength >= maxLength) {
            var next = target;
            while (next = next.nextElementSibling) {
                if (next == null) break;
                if (next.tagName.toLowerCase() == "input") {
                    next.focus();
                    break;
                }
            }
        }

        if (myLength === 0) {
            var next = target;
            while (next = next.previousElementSibling) {
                if (next == null) break;
                if (next.tagName.toLowerCase() == "input") {
                    next.focus();
                    break;
                }
            }
        }
    }, false);

    pinContainer.addEventListener('keydown', function (event) {
        var target = event.srcElement;
        target.value = "";
    }, false);
}
